import debraPic from "@/public/images/artists/debra.png";
import { Artist } from "@/types/types";

export const debra = {
  id: "202",
  name: "Debra",
  image: debraPic,
  description: `Debra's voice is deep and commanding, with a smoky timbre that conveys power and poise, perfectly matching the energy of soulful dance and disco tracks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdebra-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Disco", "Soul", "Ballads", "Dance", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 47,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
